import * as z from 'zod';

import { Timestamp } from './db/firestore';

export const APITOKEN_LABEL_LIMIT = 50;

/**
 * Personal API tokens created by an user.
 */
export const APITokenSchema = z.object({
    /**
     * Unique ID of the token. If not available (in the case of older tokens), createdAt can be treated as a unique identifier.
     * @deprecated
     */
    key: z.string().optional(),
    /**
     * Text label to identify the token.
     */
    label: z.string().max(APITOKEN_LABEL_LIMIT),
    /**
     * The token itself.
     * When creating a token, we enforce the prefix.
     * Older tokens may not have the prefix, but tokens can't be updated anyway.
     */
    token: z.string().regex(/^gb_api_[a-zA-Z0-9]+/),
    /**
     * User who created and owns this token.
     */
    user: z.string(),
    /**
     * When the token was created.
     */
    createdAt: z.instanceof(Timestamp),
    /**
     * Multiplier applied to rate limits.
     * Ex: 2 means that the token can be used for twice as many requests as a normal token.
     * @default 1
     */
    rateLimitsMultiplier: z.number().optional(),
    /**
     * Whether the token allows the use of staff capabilities.
     * Authentication should still validate that the user owning the token is a staff member.
     */
    staff: z.boolean().default(false).optional(),
    /**
     * The duration of content API token generated when using this token.
     * In seconds.
     */
    contentTokenDuration: z.number().optional(),
    /**
     * Whether tracking of requests using this token is disabled.
     */
    disableTracking: z.boolean().default(false).optional(),
});
export type APIToken = z.infer<typeof APITokenSchema>;
